<wl-structured-data [structuredData]="structuredData()" />
<wl-content-section [id]="id()" [theme]="theme()">
  <wl-accordion
    [feedbackSettings]="feedbackSettings()"
    [accordion]="accordion()"
  />
</wl-content-section>
